/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// import MakeDonationWidget from "./components/make-donation/MakeDonationWidget";



require('./bootstrap');
import { createApp } from 'vue'
import { store } from './store'

import Notifications from '@kyvg/vue3-notification'

import mitt from 'mitt'
const emitter = mitt();

import vClickOutside from "click-outside-vue3"
import SocialSharing from 'vue-social-sharing'

import FloatingVue from 'floating-vue'



// import VueObserveVisibility from 'vue-observe-visibility'
// Vue.use(VueObserveVisibility)
//

//
// var VueScrollTo = require('vue-scrollto')
// Vue.use(VueScrollTo, {
//   duration: 1500,
// })
//
// // import { Datetime } from 'vue-datetime'
// import 'vue-datetime/dist/vue-datetime.css'
// // Vue.use(Datetime)
//
//
// Vue.component('Multiselect', require('vue-multiselect').default)
// import 'vue-multiselect/dist/vue-multiselect.min.css'
//
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// // Install BootstrapVue
// Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)
//
// // import CKEditor from '@ckeditor/ckeditor5-vue2';
// // Vue.use( CKEditor );
//
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme
// Vue.use(VueQuillEditor, /* { default global options } */)
//
// import vClickOutside from 'v-click-outside'
// Vue.use(vClickOutside)
//

//
// import VueSimpleAlert from "vue-simple-alert";
// Vue.use(VueSimpleAlert);

// Vue.component('campaign-page', require('./components/campaigns/campaign-page/CampaignPage.vue').default);
// Vue.component('my-donate-button', require('./components/donate-button/MyDonateButton.vue').default);
// Vue.component('my-sticky-donate-button', require('./components/donate-button/MyStickyDonateButton.vue').default);
//
// // Vue.component('campaign-event', require('./components/campaigns/campaign-event/CampaignEvent.vue').default); not used anymore 5/13/21
// Vue.component('add-campaign-event-button', require('./components/campaigns/campaign-event/AddCampaignEventButton.vue').default);
// Vue.component('edit-campaign-event-link', require('./components/campaigns/campaign-event/EditCampaignEventLink.vue').default);
//
// Vue.component('profile-form', require('./components/settings/ProfileForm.vue').default);
// Vue.component('donation-widget', require('./components/make-donation/MakeDonationWidget.vue').default);
// Vue.component('donation-widget-no-modal', require('./components/make-donation/MakeDonationWidgetNonModal.vue').default);

//
// Vue.component('date-time-picker', require('./components/utilities/DateTimePicker.vue').default);
// Vue.component('mobile-top-navigation', require('./components/layout/MobileTopNavigation.vue').default);
// Vue.component('crud-button', require('./components/general/CrudButton.vue').default);


// // Vue.component('pledge-drive-campaign-goal', require('./components/campaigns/campaign-page/campaign-goal/PledgeDriveCampaignGoal.vue').default);

import Dashboard from './components/dashboard/Dashboard.vue'
import ImpactSlider from './components/impact-slider/ImpactSlider.vue'

import CampaignEvent from './components/campaigns/campaign-event/CampaignEvent.vue'
import AddCampaignEventButton from './components/campaigns/campaign-event/AddCampaignEventButton.vue'
import EditCampaignEventLink from './components/campaigns/campaign-event/EditCampaignEventLink.vue'

import ProfileForm from './components/settings/ProfileForm.vue'

import CheckDeposit from './components/deposits/CheckDeposit.vue'
import CreateDepositButton from './components/deposits/CreateDepositButton.vue'
import CloseDepositButton from './components/deposits/CloseDepositButton.vue'
import DepositNameLink from './components/deposits/DepositNameLink.vue'
import DepositIdLink from './components/deposits/DepositIdLink.vue'
import AddFileToDepositButton from './components/deposits/AddFileToDepositButton.vue'
import OpenDepositCrudButton from './components/deposits/OpenDepositCrudButton.vue'
import CompletedDepositCrudButton from './components/deposits/CompletedDepositCrudButton.vue'
import RemoveDepositFileCrudButton from './components/deposits/RemoveDepositFileCrudButton.vue'
import DepositViewPageCrudButton from './components/deposits/DepositViewPageCrudButton.vue'

import CampaignSignUpThankYou from './components/campaigns/CampaignSignUpThankYou.vue'
import MakePledgeWidget from './components/campaigns/campaign-page/pledge-drives/MakePledgeWidget.vue'
import MakePledgeWidgetNonModal from './components/campaigns/campaign-page/pledge-drives/MakePledgeWidgetNonModal.vue'
import AddPledgeActivityButton from './components/campaigns/campaign-page/pledge-drives/AddPledgeActivityButton.vue'
import AddPledgeButton from './components/campaigns/campaign-page/pledge-drives/AddPledgeButton.vue'
import ImportPledgeButton from './components/campaigns/campaign-page/pledge-drives/ImportPledgeButton.vue'


import CampaignStats from './components/admin/reports/CampaignStats.vue'
import CampaignStatListResult from './components/admin/reports/CampaignStatListResult.vue'

import RepresentativePage from './components/admin/representatives/RepresentativePage.vue'
import RepresentativeList from './components/admin/representatives/RepresentativeList.vue'
import RepresentativeCrudButton from './components/admin/representatives/RepresentativeCrudButton.vue'
import RepresentativeForm from './components/admin/representatives/RepresentativeForm.vue'
import RepresentativeModal from './components/admin/representatives/RepresentativeModal.vue'


import TopHeader from './components/layout/TopHeader.vue'
import DesktopSidebar from './components/layout/DesktopSidebar.vue'
import MobileLeftNavigation from './components/layout/MobileLeftNavigation.vue'
import DigPinkFooter from './components/layout/DigPinkFooter.vue'

import EditCampaign from './components/campaigns/EditCampaign.vue'
import CampaignPage from './components/campaigns/campaign-page/CampaignPage.vue'
import CampaignPageLegacy from './components/campaigns/campaign-page/CampaignPageLegacy.vue'
import MyStickyDonateButton from './components/donate-button/MyStickyDonateButton.vue'
import MyDonateButton from './components/donate-button/MyDonateButton.vue'
import MyDonateButtonHeader from './components/donate-button/MyDonateButtonHeader.vue'
import ShareLink from './components/share-link/ShareLink.vue'

import DonationSearchCrudButton from './components/donation-search/DonationSearchCrudButton.vue'
import DonationSearch from './components/donation-search/DonationSearch.vue'
import MoveDonation from './components/donation-search/MoveDonation.vue'

import UserSearchCrudButton from './components/user-search/UserSearchCrudButton.vue'
import UserSearch from './components/user-search/UserSearch.vue'
import EditAUser from './components/user-search/EditAUser.vue'

import CampaignSearchInput from './components/campaigns/CampaignSearchInput.vue'

import CampaignSearchCrudButton from './components/campaign-search/CampaignSearchCrudButton.vue'
import CampaignSearch from './components/campaign-search/CampaignSearch.vue'
import MoveCampaign from './components/campaign-search/MoveCampaign.vue'

import SupportACampaign from './components/campaigns/SupportACampaign.vue'

import CampaignCard from './components/campaign-card/CampaignCard.vue'
import CampaignCardList from './components/campaign-card/CampaignCardList.vue'
import CampaignCardCrudButton from './components/campaign-card/CampaignCardCrudButton.vue'
import UpdateCampaignCardModal from './components/campaign-card/UpdateCampaignCardModal.vue'

import VueGoogleMaps from '@fawmi/vue-google-maps'
import VueScrollTo from 'vue-scrollto'
import VueSmoothScroll from 'vue3-smooth-scroll'


const app = createApp({});

app.use(Notifications)
app.use(vClickOutside)
app.use(SocialSharing)
app.use(FloatingVue)

app.use(store)

app.use(VueScrollTo, {
    duration: 1500,
    offset: -100
})

app.use(VueSmoothScroll, {
    duration: 400,
})

app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBxD0ASpTA8JUwY1EY0uPWDoMTqn3ONYuw',
        libraries: "places",
    },
})

app.component('dashboard',  Dashboard)

app.component('impact-slider', ImpactSlider)
app.component('add-campaign-event-button',  AddCampaignEventButton)
app.component('campaign-event',  CampaignEvent)
app.component('edit-campaign-event-link',  EditCampaignEventLink)

app.component('profile-form',  ProfileForm)
app.component('user-search',  UserSearch)
app.component('user-search-crud-button',  UserSearchCrudButton)
app.component('edit-a-user',  EditAUser)

app.component('check-deposit',  CheckDeposit)
app.component('create-deposit-button',  CreateDepositButton)
app.component('close-deposit-button',  CloseDepositButton)
app.component('deposit-name-link',  DepositNameLink)
app.component('deposit-id-link',  DepositIdLink)
app.component('add-file-to-deposit-button',  AddFileToDepositButton)
app.component('open-deposit-crud-button',  OpenDepositCrudButton)
app.component('completed-deposit-crud-button',  CompletedDepositCrudButton)
app.component('remove-deposit-file-crud-button',  RemoveDepositFileCrudButton)
app.component('deposit-view-page-crud-button',  DepositViewPageCrudButton)


app.component('campaign-sign-up-thank-you',  CampaignSignUpThankYou)

app.component('make-pledge-widget',  MakePledgeWidget)
app.component('make-pledge-widget-non-modal',  MakePledgeWidgetNonModal)
app.component('add-pledge-activity-button',  AddPledgeActivityButton)
app.component('add-pledge-button',  AddPledgeButton)
app.component('import-pledge-button',  ImportPledgeButton)

app.component('campaign-card',  CampaignCard)
app.component('campaign-card-list',  CampaignCardList)
app.component('campaign-card-crud-button',  CampaignCardCrudButton)
app.component('update-campaign-card-modal',  UpdateCampaignCardModal)

app.component('support-a-campaign',  SupportACampaign)
app.component('campaign-search',  CampaignSearch)
app.component('campaign-search-crud-button',  CampaignSearchCrudButton)
app.component('move-campaign',  MoveCampaign)

app.component('campaign-search-input',  CampaignSearchInput)

app.component('donation-search',  DonationSearch)
app.component('donation-search-crud-button',  DonationSearchCrudButton)
app.component('move-donation',  MoveDonation)

app.component('edit-campaign',  EditCampaign)
app.component('campaign-page',  CampaignPage)
app.component('campaign-page-legacy',  CampaignPageLegacy)
app.component('my-sticky-donate-button',  MyStickyDonateButton)
app.component('my-donate-button',  MyDonateButton)
app.component('my-donate-button-header',  MyDonateButtonHeader)
app.component('share-link',  ShareLink)

app.component('campaign-stats',  CampaignStats)
app.component('campaign-stat-list-result',  CampaignStatListResult)

app.component('representative-page',  RepresentativePage)
app.component('representative-list',  RepresentativeList)
app.component('representative-crud-button',  RepresentativeCrudButton)
app.component('representative-form',  RepresentativeForm)
app.component('representative-modal',  RepresentativeModal)

app.component('top-header',  TopHeader)
app.component('desktop-sidebar',  DesktopSidebar)
app.component('mobile-left-navigation',  MobileLeftNavigation)
app.component('dig-pink-footer',  DigPinkFooter)

app.component('donation-widget-iframe', require('./components/make-donation/DonationWidgetIframe.vue').default);

app.config.globalProperties.emitter = emitter;
app.mount('#app')

// const app = new Vue({
//   el: '#app',
//   store
// });
